module.exports = [{
      plugin: require('/Volumes/My Passport for Mac/cabident/SuperProps - React Next Landing Page Templates/SuperPropsOnefan/packages/landing-gatsby/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
